import {
  ChartC01,
  ChartC02,
  ChartC03,
  ChartC04,
  ChartC05,
  ChartC06,
  ChartC07,
  ChartC08,
  ChartC09,
  ChartC10,
  ChartC11,
  ChartC12,
  ChartC13,
  ChartC14,
  ChartC15,
  ChartC16,
  ChartC17,
  ChartC18,
  ChartC19,
  ChartC20,
  ChartC21,
  ChartC22,
  ChartC23,
  ChartC24,
  ThemeDefinition,
} from '@tanium/react-theme-definition';

export const defaultPalette: readonly ThemeDefinition[] = [
  ChartC01,
  ChartC02,
  ChartC03,
  ChartC04,
  ChartC05,
  ChartC06,
  ChartC07,
  ChartC08,
  ChartC09,
  ChartC10,
  ChartC11,
  ChartC12,
  ChartC13,
  ChartC14,
  ChartC15,
  ChartC16,
  ChartC17,
  ChartC18,
  ChartC19,
  ChartC20,
  ChartC21,
  ChartC22,
  ChartC23,
  ChartC24,
];
